import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "gk-dialog",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = { class: "gk-badge" }
const _hoisted_3 = {
  key: 1,
  class: "gk-dialog__text"
}
const _hoisted_4 = {
  class: "gk-options",
  role: "radiogroup"
}
const _hoisted_5 = ["aria-checked", "onClick", "onKeydown"]
const _hoisted_6 = { class: "gk-option__body" }
const _hoisted_7 = { class: "gk-option__label" }
const _hoisted_8 = {
  key: 0,
  class: "gk-option__hint"
}
const _hoisted_9 = {
  key: 2,
  class: "gk-dialog__hint"
}
const _hoisted_10 = { class: "gk-dialog__actions" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "gk-dialog__icon" }
const _hoisted_13 = { class: "gk-dialog__actions gk-dialog__actions--single" }

import { ref, computed, PropType } from 'vue';
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component/use-dialog-plugin-component.js';;

type SignAnswer = 'yes' | 'no' | 'unknown' | 'ukep' | 'unep';

type SignOption = {
  label: string,
  value: SignAnswer,
  hint?: string,
};


export default /*@__PURE__*/_defineComponent({
  __name: 'GoskluchSignDialog',
  props: {
  mode: {
    type: String as PropType<'choose' | 'agreement'>,
    default: 'choose',
  },
  // Соглашение для УНЭП подписано — даём выбрать вид подписи
  unepAllowed: {
    type: Boolean,
    default: false,
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props;



const {
  dialogRef, onDialogHide, onDialogOK, onDialogCancel,
} = useDialogPluginComponent();

const UKEP_QUESTION_OPTIONS: SignOption[] = [
  { label: 'Да, есть', value: 'yes' },
  { label: 'Нет', value: 'no' },
  { label: 'Не знаю', value: 'unknown' },
];

const SIGN_TYPE_OPTIONS: SignOption[] = [
  { label: 'УКЭП', value: 'ukep', hint: 'Усиленная квалифицированная электронная подпись' },
  { label: 'УНЭП', value: 'unep', hint: 'Усиленная неквалифицированная электронная подпись' },
];

const options = computed(() => (props.unepAllowed ? SIGN_TYPE_OPTIONS : UKEP_QUESTION_OPTIONS));

const answer = ref<SignAnswer | null>(null);

const submit = () => {
  if (answer.value) onDialogOK(answer.value);
};

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "gk-dialog__close",
          type: "button",
          "aria-label": "Закрыть",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onDialogCancel) && _unref(onDialogCancel)(...args)))
        }, [
          _createVNode(_component_q_icon, {
            name: "close",
            size: "24px"
          })
        ]),
        (__props.mode === 'choose')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "gk-dialog__title" }, "Подписание через Госключ", -1)),
              (__props.unepAllowed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_q_icon, {
                        name: "check_circle",
                        size: "20px",
                        class: "gk-badge__icon"
                      }),
                      _cache[3] || (_cache[3] = _createElementVNode("span", null, " Соглашение о признании электронной подписи аналогом собственноручной подписано ", -1))
                    ]),
                    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "gk-dialog__text" }, "Выберите вид электронной подписи", -1))
                  ], 64))
                : (_openBlock(), _createElementBlock("p", _hoisted_3, " Есть ли у вас усиленная квалифицированная электронная подпись (УКЭП)? ")),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.value,
                    class: _normalizeClass(['gk-option', { 'gk-option--selected': answer.value === item.value }]),
                    role: "radio",
                    tabindex: "0",
                    "aria-checked": answer.value === item.value,
                    onClick: ($event: any) => (answer.value = item.value),
                    onKeydown: [
                      _withKeys(_withModifiers(($event: any) => (answer.value = item.value), ["prevent"]), ["enter"]),
                      _withKeys(_withModifiers(($event: any) => (answer.value = item.value), ["prevent"]), ["space"])
                    ]
                  }, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "gk-option__radio" }, null, -1)),
                    _createElementVNode("span", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(item.label), 1),
                      (item.hint)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(item.hint), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 42, _hoisted_5))
                }), 128))
              ]),
              (!__props.unepAllowed)
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Если не уверены — выберите «Не знаю»: мы проверим возможность подписания усиленной неквалифицированной электронной подписью (УНЭП). "))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "gk-btn gk-btn--secondary",
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onDialogCancel) && _unref(onDialogCancel)(...args)))
                }, " Отмена "),
                _createElementVNode("button", {
                  class: "gk-btn gk-btn--primary",
                  type: "button",
                  disabled: !answer.value,
                  onClick: submit
                }, " Продолжить ", 8, _hoisted_11)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_q_icon, {
                  name: "info_outline",
                  size: "28px"
                })
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "gk-dialog__title" }, "Требуется соглашение", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "gk-dialog__text" }, " Для подписания усиленной неквалифицированной электронной подписью (УНЭП) необходимо соглашение о признании электронной подписи аналогом собственноручной. ", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("p", { class: "gk-dialog__text" }, " Обратитесь к администраторам медицинского центра для его подписания. ", -1)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  class: "gk-btn gk-btn--primary",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(onDialogOK)()))
                }, " Понятно ")
              ])
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})